import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        box-sizing: border-box;
        scroll-behavior: smooth;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
    iframe,
    embed {
        border: none;
        max-width: 100%;
    }
    body {
        margin: 0;
        overflow-x: hidden;
    }
    img,
    video {
        max-width: 100%;
        height: auto;
    }
    li {
        overflow-wrap: anywhere;
        word-break: break-word;
    }
`;

export default GlobalStyle;
